import { TopLevelSpec as VegaLiteSpec } from 'vega-lite';
import { TimeUnit } from 'vega-lite/build/src/timeunit';
import { liteBaseConfig } from '../vegaShared';

export interface IBarTimelineOptions {
  data: any[];
  timeUnit: TimeUnit;
  xField: string;
  color?: string;
  xAxisTitle?: string;
  yAxisTitle?: string;
  xLabels?: boolean;
  yLabels?: boolean;
  width?: number | 'container';
  height?: number | 'container';
}

export const genBarTimelineSpec = (options: IBarTimelineOptions): VegaLiteSpec => {
  const xAxis = { labelAngle: 0, title: options.xAxisTitle || null, labels: !!options.xLabels, domain: !!options.xLabels, ticks: !!options.xLabels };
  const yAxis = { title: options.yAxisTitle || null, labels: !!options.yLabels, domain: !!options.yLabels, ticks: !!options.yLabels };
  const config = {
    ...liteBaseConfig(),
  };
  const baseSpec: VegaLiteSpec = {
    $schema: 'https://vega.github.io/schema/vega-lite/v4.json',
    autosize: 'fit',
    width: options.width || 'container',
    height: options.height || 100,
    mark: {
      type: 'bar',
      tooltip: true,
      color: options.color || '#6d6156',
      stroke: 'white',
      strokeWidth: 2,
      cornerRadiusTopLeft: 2,
      cornerRadiusTopRight: 2,
    },
    config,
    encoding: {
      x: { field: options.xField, timeUnit: { unit: options.timeUnit }, type: 'temporal', axis: xAxis },
      y: { aggregate: 'count', axis: yAxis },
    },
    data: { values: options.data },
  };
  return baseSpec;
};
